import React from 'react'

import Modal from 'react-bootstrap/Modal'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

import { Spinner } from '../../LoadingContainer/Spinner'

export default function Confirm({
  title,
  description,
  onConfirm,
  onClose,
  confirming = false,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
}) {
  return (
    <Modal.Body>
      <div className="modal-body-heading">
        <h1 className="modal-body-heading-title">{title}</h1>
        <p>{description}</p>
      </div>
      <Stack className="btn-group-flex">
        <Button
          variant="outline-light"
          size="lg"
          className="btn-width text-danger"
          onClick={onConfirm}
          disabled={confirming}
        >
          {confirming ? <Spinner variant="dark" /> : confirmLabel}
        </Button>
        <Button size="lg" onClick={onClose}>
          {cancelLabel}
        </Button>
      </Stack>
    </Modal.Body>
  )
}
